export const vooiLineaPoolIdMapping: Record<string, number> = {
    '0x4af15ec2a0bd43db75dd04e62faa3b8ef36b00d5': 2, // DAI
    '0xa219439258ca9da29e9cc4ce5596924745e12b93': 1, // USDT
    '0x176211869ca2b568f2a7d4ee941e073a821ee1ff': 0 // USDC
};
